/** @format */

export const sleep = (timeout: number): Promise<void> =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, timeout);
  });
